export default __webpack_public_path__ + "static/media/masaref-shorb.f4a1f1e5.png";